// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.breadcrumb-vue {\n        margin-bottom: 14px;\n        padding: 11px;\n        border-radius: 4px;\n        background: white;\n}\n.link-right-breadcrumb {\n        position: absolute;\n        right: 11px;\n        top: 8px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
